// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var UnorderedList = function UnorderedList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.333 2a1.333 1.333 0 1 0 0 2.667 1.333 1.333 0 0 0 0-2.667m5 .333c-.554 0-1 .446-1 1 0 .555.446 1 1 1H19c.554 0 1-.445 1-1s-.446-1-1-1zm0 6.667c-.554 0-1 .446-1 1s.446 1 1 1H19c.554 0 1-.446 1-1s-.446-1-1-1zm0 6.667c-.554 0-1 .446-1 1s.446 1 1 1H19c.554 0 1-.446 1-1 0-.555-.446-1-1-1zM2.667 10A1.333 1.333 0 1 0 0 10a1.333 1.333 0 0 0 2.667 0m-1.334 5.333a1.333 1.333 0 1 0 0 2.667 1.333 1.333 0 0 0 0-2.667"
  }));
};
